import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';


@Component({
  selector: 'app-step8-data',
  templateUrl: './step8-data.component.html',
  styleUrls: ['./step8-data.component.scss']
})
export class Step8DataComponent implements OnInit {
  dataId : any ;
  dataStep8_inf = [
    {
      position: 81, 
      tittle: '8.1 Para la prevención de los factores de riesgo psicosocial y la violencia laboral, así como para la promoción del entorno organizacional favorable, los centros de trabajo deberán:', 
      infoA: "A) Establecer acciones para la prevención de los factores de riesgo psicosocial que impulsen: el apoyo social, la difusión de la información y la capacitación;", 
      infoB: "B) Disponer de mecanismos seguros y confidenciales para la recepción de quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral, ",
      infoC: "c) Realizar acciones que promuevan el sentido de pertenencia de los trabajadores a la organización; la capacitación para la adecuada realización de las tareas encomendadas; la definición precisa de responsabilidades para los miembros de la organización; la participación proactiva y comunicación entre sus integrantes; la distribución adecuada de cargas de trabajo, con jornadas laborales regulares conforme a la Ley Federal del Trabajo, y la evaluación y el reconocimiento del desempeño.",
      infoD: "",
      infoE: "",
      infoF: "",
      infoG: "",
    },
    {
      position: 82, 
      tittle: '8.2 Las acciones y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno organizacional favorable y la prevención de la violencia laboral, referidas en el numeral anterior, deberán considerar lo siguiente', 
      infoA: "A) En relación con el liderazgo y las relaciones en el trabajo deberán incluir: ", 
      infoB: "B) Respecto a las cargas de trabajo deberán contener:",
      infoC: "C) En lo que se refiere al control de trabajo deberán comprender:",
      infoD: "D) En lo relativo al apoyo social deberán incluir actividades que permitan:",
      infoE: "E) En relación con el equilibrio en la relación trabajo-familia, contemplar:",
      infoF: "F) Respecto al reconocimiento en el trabajo deberán contar con mecanismos que permitan:",
      infoG: "G) En lo que se refiere a la prevención de la violencia laboral se deberá:",
    },
    {
      position: 85,
      tittle: "8.5 El tipo de acciones deberán realizarse, según aplique, en los niveles siguientes:",
      infoA: "A) Primer nivel: Las acciones se centran en el plano organizacional e implican actuar sobre la política de prevención de riesgos psicosociales del centro de trabajo, la organización del trabajo, las acciones o medios para: disminuir los efectos de los factores de riesgo psicosocial, prevenir la violencia laboral y propiciar el entorno organizacional favorable.",
      infoB: "B)  Segundo nivel: Las acciones se orientan al plano grupal e implica actuar en la interrelación de los trabajadores o grupos de ellos y la organización del trabajo; su actuación se centra en el tiempo de trabajo, el comportamiento y las interacciones personales, se basan en proporcionar información al trabajador, así como en la sensibilización, (contempla temas como: manejo de conflictos, trabajo en equipo, orientación a resultados, liderazgo, comunicación asertiva, administración del tiempo de trabajo, entre otros), y reforzar el apoyo social, y/o",
      infoC: "C)  Tercer nivel: Las acciones se enfocan al plano individual; es decir, se desarrolla cuando se comprueba que existen signos y/o síntomas que denotan alteraciones en la salud, se incluyen intervenciones de tipo clínico o terapéutico.",
      infoD: "Las intervenciones de tercer nivel que sean de tipo clínico o terapéutico deberán ser realizadas invariablemente por un médico, psicólogo o psiquiatra según corresponda.",
      infoE: "",
      infoF: "",
      infoG: "",

    }
    
  ]

  constructor(private activated: ActivatedRoute) {
  }

  ngOnInit() {
    this.activated.data.subscribe  (params=>{this.dataId = params});
  console.log(this.dataId);
  }

}
